(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Smooth open/close for the phone menu, one group open at a time per level. */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function panelOf(d) { return d.querySelector(':scope > :not(summary)'); }
    function run(d, open) {
      var panel = panelOf(d);
      d._target = open;
      if (!panel || reduce.matches || !panel.animate) { d.open = open; return; }
      var from = d.open ? panel.getBoundingClientRect().height : 0;
      if (d._anim) d._anim.cancel();
      d.open = true;
      var to = open ? panel.scrollHeight : 0;
      panel.style.overflow = 'hidden';
      var anim = panel.animate(
        { height: [from + 'px', to + 'px'], opacity: open ? [from ? 1 : 0, 1] : [1, 0] },
        { duration: open ? 320 : 240, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
      d._anim = anim;
      anim.onfinish = function () {
        d._anim = null;
        panel.style.overflow = '';
        if (!open) d.open = false;
      };
    }
    document.addEventListener('click', function (e) {
      var summary = e.target.closest('.mobile-nav summary');
      if (!summary) return;
      var d = summary.parentElement;
      e.preventDefault();
      var current = d._target === undefined ? d.open : d._target;
      var willOpen = !current;
      if (willOpen && d.dataset.navAcc) {
        var list = d.parentElement.parentElement;
        Array.prototype.forEach.call(list.children, function (li) {
          var other = li.querySelector(':scope > details[data-nav-acc]');
          if (!other || other === d) return;
          var otherOpen = other._target === undefined ? other.open : other._target;
          if (otherOpen) run(other, false);
        });
      }
      run(d, willOpen);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verae-lab-existing"] && !Shopify.designMode) return;
  try {
    
  /* Open the free guide when someone arrives at #vl-existing-guide or taps a link to it. */
  (function () {
    function openGuide(scroll) {
      var guide = document.querySelector('[data-vl-free]');
      if (!guide) return;
      guide.open = true;
      if (scroll) document.getElementById('vl-existing-guide').scrollIntoView({ block: 'start' });
    }
    if (location.hash === '#vl-existing-guide') openGuide(true);
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#vl-existing-guide"]');
      if (link && document.getElementById('vl-existing-guide')) openGuide(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verae-lab-routine"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.vl-program .vl-exercises a[href^="#vl-"]');
  if (!link) return;
  const panel = document.getElementById(link.getAttribute('href').slice(1));
  if (panel && panel.matches('details.vl-technical')) panel.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
